export default "__VITE_PUBLIC_ASSET__3aaae8d5__"